import { BAlert } from './alert';
import { pluginFactory } from '../../utils/plugins';
var AlertPlugin = /*#__PURE__*/pluginFactory({
  components: {
    BAlert: BAlert
  }
});
export { AlertPlugin, BAlert };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/components/alert/index.js
// module id = 294
// module chunks = 44